import React from 'react'
import {Tag, UserEvent} from 'yougile-model'
import {Sync} from '@client/sync'
import {Icon} from '@components/common/base/icon'
import {Sticker} from '@extensions/sticker/sticker'
import AddSVG from './svg/add.svg'
import ArchiveSVG from './svg/archive.svg'
import ChatSVG from './svg/chat.svg'
import CompleteSVG from './svg/complete.svg'
import DeleteSVG from './svg/delete.svg'
import EditSVG from './svg/edit.svg'
import FilesSVG from './svg/files.svg'
import MoveSVG from './svg/move.svg'
import RestoreSVG from './svg/restore.svg'
import RightsSVG from './svg/rights.svg'
import UsersSVG from './svg/users.svg'

interface Props {
  event: UserEvent
}

// eslint-disable-next-line max-lines-per-function
export const ActionIcon = ({event}: Props) => {
  switch (event.type) {
    case 'add': {
      return (
        <div className="flex text-action-default">
          <AddSVG />
        </div>
      )
    }
    case 'delete': {
      return (
        <div className="flex text-error-old">
          <DeleteSVG />
        </div>
      )
    }
    case 'restore': {
      return (
        <div className="flex text-action-default">
          <RestoreSVG />
        </div>
      )
    }
    case 'rename': {
      return (
        <div className="flex text-action-default">
          <EditSVG />
        </div>
      )
    }
    case 'move': {
      return (
        <div className="flex text-action-default">
          <MoveSVG />
        </div>
      )
    }
    case 'complete': {
      return (
        <div className="flex text-action-default">
          <ArchiveSVG />
        </div>
      )
    }
    case 'uncomplete': {
      return (
        <div className="flex text-action-default">
          <RestoreSVG />
        </div>
      )
    }
    case 'done': {
      return (
        <div className="flex text-success-old">
          <CompleteSVG />
        </div>
      )
    }
    case 'deadline':
    case 'deadlineFailed': {
      return (
        <div className="flex items-center justify-center text-success-old w-24 min-w-24 h-24">
          <Icon icon="IconCalendarEvent" size={16} color="interactive"></Icon>
        </div>
      )
    }
    case 'undone': {
      return (
        <div className="flex items-center justify-center text-success-old w-24 min-w-24 h-24">
          <Icon icon="IconCircleCheck" size={16}></Icon>
        </div>
      )
    }

    case 'stopwatch': {
      return (
        <div className="flex items-center justify-center text-success-old w-24 min-w-24 h-24">
          <Icon icon="IconCustomStopwatch" size={16}></Icon>
        </div>
      )
    }
    case 'timer': {
      return (
        <div className="flex items-center justify-center text-success-old w-24 min-w-24 h-24">
          <Icon icon="IconCustomTimer" size={16}></Icon>
        </div>
      )
    }
    case 'timetracking': {
      return (
        <div className="flex items-center justify-center text-success-old w-24 min-w-24 h-24">
          <Icon icon="IconCustomTimeTracking" size={16}></Icon>
        </div>
      )
    }

    case 'message': {
      return (
        <div className="flex text-action-default">
          <ChatSVG />
        </div>
      )
    }
    case 'sprint': {
      return (
        <div className="flex items-center justify-center w-24 min-w-24 h-24">
          <Icon icon="IconCustomCalendar" className="mr-8 text-main-old" />
        </div>
      )
    }

    case 'text':
    case 'numeric':
    case 'string': {
      if (!event?.options?.id) {
        return <></>
      }
      const tag = Sync.getCurrentSandbox().get(event?.options?.id) as
        | Tag
        | undefined

      if (!tag) {
        return <></>
      }

      const icon = Sticker.getIcon(tag)
      return (
        <div className="flex items-center justify-center w-24 min-w-24 h-24">
          <Icon icon={icon || 'IconCustomBan'} />
        </div>
      )
    }
    case 'users':
    case 'add-user-to-project':
    case 'remove-user-from-project':
    case 'executor': {
      return (
        <div className="flex text-action-default">
          <UsersSVG />
        </div>
      )
    }
    case 'change-project-roles':
    case 'change-project-permissions': {
      return (
        <div className="flex text-action-default">
          <RightsSVG />
        </div>
      )
    }
    case 'file': {
      return (
        <div className="flex text-action-default">
          <FilesSVG />
        </div>
      )
    }
    default:
      return <>???</>
  }
}
